export default __webpack_public_path__ + "static/icecream-health-2-desktop-632ecbddbd8c58d04e212f3ccfbb28ab.png";